import React from 'react'
import DataTable, { TableAction, TableColumn } from '../../../shared/components/DataTable'
import { CarFilteredDTO } from './CarModel'

type Props = {
  data: CarFilteredDTO[]
  currentPage: number
  totalPages: number
  pageSize: number 
  onPageSizeChange?: (size: number) => void
  onPageChange: (page: number) => void  
  onEdit?: (car: CarFilteredDTO) => void  
  onDelete?: (car: CarFilteredDTO) => void 
  sortBy?: string  
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const CarTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize, 
  onPageSizeChange, 
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const columns: TableColumn<CarFilteredDTO>[] = [
  {
    key: 'plate',
    label: 'Plaka',
    sortable: true,
    width: '120px',
    align: 'center'
  },
  {
    key: 'brand',
    label: 'Marka',
    sortable: true,
    width: '150px'
  },
  {
    key: 'modelType',
    label: 'Model Tipi',
    sortable: false,
    width: '150px'
  },
  {
    key: 'detail',
    label: 'Detay',
    sortable: false,
    width: '200px' 
  },
  {
    key: 'modelYear',
    label: 'Model Yılı',
    sortable: true,
    width: '100px',
    align: 'center'
  },
  {
    key: 'fuelType',
    label: 'Yakıt Tipi',
    sortable: false,
    width: '120px'
  },
  {
    key: 'transmission',
    label: 'Vites Tipi',
    sortable: false,
    width: '120px'
  },
  {
    key: 'branch',
    label: 'Şube',
    sortable: true,
    width: '180px',
  },
  {
    key: 'vehicleGroup',
    label: 'Araç Grubu',
    sortable: false,
    width: '250px',
  },
  {
    key: 'chassisNumber',
    label: 'Şasi No',
    sortable: false,
    width: '180px'
  },
  {
    key: 'lastKm',
    label: 'Son KM',
    sortable: true,
    width: '120px',
    align: 'right'
  },
  {
    key: 'color',
    label: 'Renk',
    sortable: false,
    width: '100px'
  },
  {
    key: 'snowTireStatus',
    label: 'Kış Lastiği',
    sortable: false,
    width: '120px'
  },
  {
    key: 'licenseDocumentNo',
    label: 'Ruhsat No',
    sortable: false,
    width: '150px'
  },
  {
    key: 'vehicleOwner',
    label: 'Araç Sahibi',
    sortable: false,
    width: '150px'
  },
  {
    key: 'status',
    label: 'Durum',
    sortable: true,
    width: '100px',
    align: 'center'
  },
  {
    key: 'vehicleTrackingNumber',
    label: 'Takip No',
    sortable: false,
    width: '150px'
  },
  {
    key: 'radioCode',
    label: 'Radyo Kodu',
    sortable: false,
    width: '120px'
  },
  {
    key: 'totalPurchasePrice',
    label: 'Alış Fiyatı',
    sortable: true,
    width: '150px',
    align: 'right'
  },
  {
    key: 'hgsNumber',
    label: 'HGS No',
    sortable: false,
    width: '150px'
  },
  {
    key: 'engineNumber',
    label: 'Motor No',
    sortable: false,
    width: '150px'
  },
  {
    key: 'description',
    label: 'Açıklama',
    sortable: false,
    width: '200px'
  },
  {
    key: 'fleetEntryDate',
    label: 'Filoya Giriş',
    sortable: true,
    width: '130px',
    align: 'center'
  },
  {
    key: 'fleetExitDate',
    label: 'Filoya Çıkış',
    sortable: true,
    width: '130px',
    align: 'center'
  },
  {
    key: 'plannedExitDate',
    label: 'Planlı Çıkış',
    sortable: true,
    width: '130px',
    align: 'center'
  },
  {
    key: 'cascoValue',
    label: 'Kasko Değeri',
    sortable: true,
    width: '150px',
    align: 'right'
  },
  ]

  

  const actions: TableAction<CarFilteredDTO>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (item) => onEdit?.(item),  
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (item) => onDelete?.(item), 
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange} 
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Araç bulunamadı.'
    />
  )
}